// extracted by mini-css-extract-plugin
export var contrastLow = "_2f-1";
export var externalLink = "_2f-2";
export var externalLinkIcon = "_2f-3";
export var link = "_2f-0";
export var linkLabel = "_2f-4";